/**
 * After create, reveal resets to All / page 1 and focuses the new row. The focus rail keeps its
 * old scrollTop, so the selected card can sit off screen. Scroll THAT card into view by row id —
 * never the rail top alone, which is wrong when sort order puts the new card mid-list.
 *
 * Returns whether the card was found and scrolled. Callers may retry after paint when false.
 */
export function revealFocusedBoardCard(rail: HTMLElement | null, focusedId: string | null): boolean {

  if (!rail || !focusedId) return false;

  const card = rail.querySelector(`[data-board-row-id="${cssEscape(focusedId)}"]`) as HTMLElement | null;
  if (!card) return false;

  card.scrollIntoView({ block: 'nearest' });
  return true;
}

/** Snap the card rail to the top of a new page when nothing is focused. */
export function scrollBoardFocusRailToTop(rail: HTMLElement | null): void {

  if (rail) rail.scrollTop = 0;
}

/** `CSS.escape` is missing in some jsdom builds — keep attribute selectors safe either way. */
function cssEscape(value: string): string {

  if (typeof CSS !== 'undefined' && typeof CSS.escape === 'function') return CSS.escape(value);
  return value.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
}
